export const HISTORY_PUSH = 'HISTORY_PUSH'
export const HISTORY_REVERT = 'HISTORY_REVERT'
export const HISTORY_GET = 'HISTORY_GET'
